import React, { useEffect, useState } from "react";
import { api } from "../api/api";
import { useNavigate } from "react-router-dom";
import "./stylesheet/AdminAccessCodes.css";
import logoSvg from "../assets/logo.svg";

export default function AdminAccessCodes() {
  const [codes, setCodes] = useState([]);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(true);
  const [copiedId, setCopiedId] = useState(null); // Estado para feedback de cópia

  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();

  // --- NOVA FUNÇÃO: COPIAR CÓDIGO ---
  const copyToClipboard = (text, id) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedId(id); // Ativa o feedback visual
      setTimeout(() => setCopiedId(null), 2000); // Remove o feedback após 2s
    });
  };

  async function loadCodes() {
    try {
      setLoading(true);
      const res = await api.get("accessCodes/listCodes.php");
      if (res.data?.success) {
        setCodes(res.data.data);
      }
    } catch {
      setErrorMessage("Erro ao carregar códigos de acesso.");
      setShowError(true);
    } finally {
      setLoading(false);
    }
  }

  async function generateCode() {
    if (!name.trim()) {
      setErrorMessage("Por favor, informe o nome da pessoa ou setor para gerar a chave.");
      setShowError(true);
      return;
    }
    try {
      const res = await api.post("accessCodes/createCode.php", { name });
      if (res.data?.success) {
        setCodes((prev) => [res.data.code, ...prev]);
        setName("");
      } else {
        setErrorMessage(res.data.message || "Erro ao gerar código");
        setShowError(true);
      }
    } catch {
      setErrorMessage("Erro de comunicação com o servidor.");
      setShowError(true);
    }
  }

 async function toggleCode(id, active) {
  try {
    const res = await api.post("accessCodes/toggleCode.php", {
      id, // Apenas uma vez aqui
      active: active ? 0 : 1
    });

    if (res.data?.success) {
      setCodes((prev) =>
        prev.map((c) =>
          c.id === id ? { ...c, active: active ? 0 : 1 } : c
        )
      );
    }
  } catch {
    setErrorMessage("Erro ao alterar status do código.");
    setShowError(true);
  }
}

  useEffect(() => { loadCodes(); }, []);

  if (loading) {
    return (
      <div className="admin-loading-container">
        <div className="loader"></div>
        <p>Carregando chaves de acesso...</p>
      </div>
    );
  }

  return (
    <div className="admin-access-page">
      <header className="portal-header">
        <div className="header-logo-group" onClick={() => navigate("/admin/dashboard")} style={{ cursor: "pointer" }}>
          <img src={logoSvg} alt="Logo" className="portal-logo-svg" />
        </div>
        <div className="header-nav-info">
          <button className="back-link-text" onClick={() => navigate("/admin/dashboard")}>
            Voltar ao Menu
          </button>
        </div>
      </header>

      <div className="access-container">
        <div className="page-intro">
            <h2 className="header-title">Códigos de Acesso</h2>
            <p className="page-subtitle">Gerencie as permissões de acesso ao portal.</p>
        </div>

        <section className="generate-section">
          <div className="generate-card">
            <h3>Gerar Nova Chave</h3>
            <div className="input-group-row">
              <input
                type="text"
                placeholder="Nome do colaborador ou setor"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="access-input"
              />
              <button className="generate-btn" onClick={generateCode}> Gerar Código </button>
            </div>
          </div>
        </section>

        <main className="codes-list">
          <h3 className="list-title">Chaves Ativas</h3>
          <div className="codes-grid">
            {codes.map((code) => (
              <div 
                key={code.id} 
                className={`code-card ${code.active ? "active" : "inactive"} ${copiedId === code.id ? "card-copied" : ""}`}
                title="Clique no código para copiar"
              >
                <div className="code-card-header">
                   <span className="user-icon">👤</span>
                   <strong>{code.name}</strong>
                </div>
                
                {/* ÁREA DE CLIQUE PARA COPIAR */}
                <div 
                  className="code-display clickable-copy" 
                  onClick={() => copyToClipboard(code.code, code.id)}
                >
                  <span className="code-label">
                    {copiedId === code.id ? "✅ COPIADO!" : "CÓDIGO DE ACESSO (CLIQUE):"}
                  </span>
                  <span className="code-value">{code.code}</span>
                </div>

                <div className="code-footer">
                  <span className={`status-badge ${code.active ? "on" : "off"}`}>
                    {code.active ? "● Ativo" : "● Inativo"}
                  </span>
                  <button
                    onClick={() => toggleCode(code.id, code.active)}
                    className={`toggle-btn ${code.active ? "btn-off" : "btn-on"}`}
                  >
                    {code.active ? "Desativar" : "Reativar"}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </main>
      </div>

      {showError && (
        <div className="error-overlay">
          <div className="error-popup-card">
            <h3>Atenção</h3>
            <p>{errorMessage}</p>
            <button className="error-close-btn" onClick={() => setShowError(false)}>Entendido</button>
          </div>
        </div>
      )}
    </div>
  );
}